module.exports = __webpack_public_path__ + "static/media/wave-sound-blue.68fbdd48.png";